import styled from 'styled-components';

export const TabsWrapper = styled.div`
  width: fit-content;
  margin: auto;
  overflow-y: auto;
`;
